<template>
  <div>
    <template v-for="(d, dind) in object.diagnoses">
      <div :key="`str-${dind}`" v-if="dind < limit">
        {{ d.title }}
      </div>
    </template>

    <div v-if="hasMore">
      <a v-if="!showAll"
         @click.stop="showAll = true"
         class="text-muted small text-lowercase d-block pointer">
        +{{ object.diagnoses.length - limit }} {{ $t('more_2') }}
      </a>
      <div v-if="showAll">
        <template v-for="(d, dind) in object.diagnoses">
          <div :key="`strs-${dind}`" v-if="dind >= limit">{{ d.title }}</div>
        </template>
        <a class="text-muted small text-lowercase d-block pointer"
           @click="showAll = false">
          {{ $t('hide2') }}
        </a>
      </div>
    </div>

<!--    <div v-if="object.diagnoses.length > limit"-->
<!--         :id="`diag-obj-pop-${object.id}`"-->
<!--         class="text-muted small text-lowercase">-->
<!--      +{{ object.diagnoses.length - limit }} {{ $t('more_2') }}-->
<!--    </div>-->
<!--    <CustomPopover :target="`diag-obj-pop-${object.id}`"-->
<!--                   v-if="object.diagnoses.length > limit"-->
<!--                   placement="top"-->
<!--                   ref="popover"-->
<!--                   :arrow="false">-->
<!--      <template v-for="(d, dind) in object.diagnoses">-->
<!--        <div :key="`strs-${dind}`" v-if="dind >= limit">{{ d.title }}</div>-->
<!--      </template>-->
<!--    </CustomPopover>-->
  </div>
</template>

<script setup>
import { computed, ref } from "vue"

const limit = 4

const showAll = ref(false)
const hasMore = computed(() => props.object.diagnoses.length > limit)

const props = defineProps({
  object: {
    type: Object
  }
})
</script>
